import { render, staticRenderFns } from "./SelOrderDetailDialog.vue?vue&type=template&id=3d376b7c&scoped=true&"
import script from "./SelOrderDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SelOrderDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d376b7c",
  null
  
)

export default component.exports